import { render } from "./MasterOrderDetails.vue?vue&type=template&id=4f3b8314&scoped=true"
import script from "./MasterOrderDetails.vue?vue&type=script&lang=js"
export * from "./MasterOrderDetails.vue?vue&type=script&lang=js"

import "./MasterOrderDetails.vue?vue&type=style&index=0&id=4f3b8314&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3b8314"]])

export default __exports__